import type { TextFieldProps } from '@mui/material/TextField';

import { Controller, useFormContext } from 'react-hook-form';

import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  ref?: React.Ref<HTMLInputElement>;
  allowZero?: boolean;
};

export function RHFTextField({ name, helperText, type, ref, allowZero = false, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          value={type === 'number' && field.value === 0 && !allowZero ? '' : field.value}
          onChange={(event) => {
            if (type === 'number') {
              const { value } = event.target;
              if (allowZero) {
                field.onChange(value === '' ? '' : Number(value));
              } else {
                field.onChange(Number(value));
              }
            } else {
              field.onChange(event.target.value);
            }
          }}
          error={!!error}
          helperText={error?.message ?? helperText}
          inputProps={{
            autoComplete: 'off',
          }}
          ref={ref}
          {...other}
        />
      )}
    />
  );
}
